import { createSelector } from "reselect";
import { getAllLanguages } from "~/store/selectors/selector.languages";
import { getLoggedUser } from "~/store/selectors/selector.users";
import { sortCompare } from "~/utils/utils.jsx";
import { getProjectById } from "./selector.projects.jsx";

export const getCurrencies = (state) => state.currencies;

export const getCurrencyByid = createSelector(
  getCurrencies,
  (state, id) => id,
  (currencies, id) => currencies[id]
);

export const getCurrenciesArray = createSelector(getCurrencies, (currencies) => Object.values(currencies));

export const getCurrenciesByIds = createSelector(
  getCurrencies,
  (_state, ids) => ids,
  (currencies, ids) =>
    ids
      .map((id) => currencies[id])
      .filter(Boolean)
      .sort((a, b) => sortCompare(a.code.toLowerCase(), b.code.toLowerCase()))
);

export const getCurrencyCodeByProjectId = createSelector(getCurrencies, getProjectById, (currencies, project) => {
  const currencyId = project.get(`currency_id`);
  const currency = currencies[currencyId];
  return currency ? currency.code : null;
});

export const getAllCurrenciesSortedByCurrencyCode = createSelector(getCurrenciesArray, (currencies) =>
  currencies.sort((c1, c2) => c1.code.localeCompare(c2.code))
);

export const getDefaultCurrency = createSelector(getCurrenciesArray, (currencies) =>
  currencies.find((curr) => curr.is_default)
);

export const getFormatCurrencyArgs = createSelector(
  getLoggedUser,
  getAllLanguages,
  getCurrencies,
  (state, idOrCode) => idOrCode,
  (user, languages, currencies, idOrCode) => {
    const langId = user.language_id;
    const language = languages[langId];
    let args = {
      decimal_separator: `.`,
      thousand_separator: `,`,
      decimal_spaces: 2,
      code: "",
    };
    if (language) {
      args = {
        ...args,
        decimal_separator: language.decimal_separator,
        thousand_separator: language.thousand_separator,
      };
    }

    let currency = null;
    if (typeof idOrCode === "number") {
      currency = currencies[idOrCode];
    } else if (typeof idOrCode === "string") {
      currency = Object.values(currencies).find((curr) => curr.code === idOrCode);
    }

    if (currency) {
      args = {
        ...args,
        decimal_spaces: currency.decimal_spaces,
        code: currency.code,
        currency_id: currency.id,
      };
    }

    return args;
  }
);
